import type { CopyShape } from "@tami/core/intl";

import type { REUSABLE_MODAL_COPY_PT_BR } from "../reusable-modal.copy";

export const REUSABLE_MODAL_COPY_ES_ES: CopyShape<
  typeof REUSABLE_MODAL_COPY_PT_BR
> = { close: "Cerrar", back: "Volver" };
